import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile } from '@sravni/react-utils';

import { OffersBlockDesktop } from './OffersBlockDesktop';
import { OffersBlockMobile } from './OffersBlockMobile';

export const OffersBlock = () => {
  const isMobile = useIsMobile();

  return (
    <Space direction="vertical" size={32} className={isMobile ? 'h-pt-16' : 'h-pt-32'} id="offers">
      {isMobile ? <OffersBlockMobile /> : <OffersBlockDesktop />}
    </Space>
  );
};
